import { RootStoreState } from '@src/models/app.types'

const uiFlagsStoreSelector = (state: RootStoreState) => state.uiFlags

export const uiFlagsSelector = (state: RootStoreState) => uiFlagsStoreSelector(state).uiFlags
